import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class UtilsBsHotToastService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'left';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private Toast: MatSnackBar) {}

  toast = this.Toast;

  show(message: string) {
    this.toast.open(message);
  }

  showError(message: string) {
    this.toast.open(message, "X" ,{
      panelClass: ['red-snackbar'],
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 5000,
    });
  }

  showSuccess(message: string) {
    this.toast.open(message, "X", {
      panelClass: ["green-snackbar"],
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
    });
  }

  showWarning(message: string, time: number = 4000) {
    this.toast.open(message, "X", {
      panelClass: ["yelow-snackbar"],
     horizontalPosition: this.horizontalPosition,
     verticalPosition: this.verticalPosition,
     duration: 3000,
    });
  }

  showInfo(message: string) {
    this.toast.open(message, "X", {
      panelClass: ["yelow-snackbar"],
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
    });
  }
}
